import './style.sass';

import React from 'react';
import FullWrapper from '../../cases/reusable-components/layouts-components__common-cases/full-wrapper';

const TargetCase = ({ listTarget }) => {
    return (
        <div className="target-case">
            <FullWrapper isMargin={0}>
                {listTarget.map((item, index) => (
                    <div key={index} className="target-case__wrapper">
                        <div className="target-case__wrapper-name">{item.name}</div>
                        <div
                            dangerouslySetInnerHTML={{ __html: item.description }}
                            className="target-case__wrapper-description"
                        />
                    </div>
                ))}
            </FullWrapper>
        </div>
    );
};
export default TargetCase;
